import { Component, Inject, OnInit } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { SubscribeInfo } from '@fantaz/shared/data-access/models/src/lib/subscribe';

@Component({
  selector: 'fz-subscribe-dialog',
  templateUrl: './subscribe-dialog.component.html',
  styleUrls: ['./subscribe-dialog.component.scss'],
})
export class SubscribeDialogComponent implements OnInit {
  form!: UntypedFormGroup;

  constructor(
    public dialogRef: MatDialogRef<SubscribeDialogComponent>,
    private formBuilder: UntypedFormBuilder,
    @Inject(MAT_DIALOG_DATA) public data: SubscribeInfo,
  ) {}

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      email: [this.data.email || '', [Validators.required, Validators.email]],
      name: [this.data.name || '', [Validators.required]],
    });
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
